<template>
    <div class="tw-fixed tw-inset-0 tw-z-[998] tw-flex tw-flex-col tw-items-center tw-justify-center tw-bg-black/30">
        <div class="tw-relative tw-w-32 tw-h-32">
            <div class="tw-absolute tw-inset-0 tw-rounded-full tw-border-4 tw-border-emerald-500/20"></div>
            <div class="tw-absolute tw-inset-0 tw-rounded-full tw-border-4 tw-border-transparent tw-border-t-emerald-500 tw-border-r-emerald-500/70 tw-animate-spin"></div>
        </div>
        <p class="tw-mt-8 tw-text-sm tw-font-medium tw-text-slate-700 dark:tw-text-slate-300 tw-animate-pulse">
            Carregando informações...
        </p>
    </div>
</template>

  